mutation updateAirdropLink($id: String, $link: String) {
    updateAirdropLink(id: $id, link: $link) 
}
